import { lazy } from 'react';

import './index.css';

const CreateEarnPage = lazy(
  () => import(/* webpackChunkName: "CreateEarnPage" */ 'views/earn/create/CreateEarn.container'),
);

const CreateEarnPopup = (symbol: string) => ({
  component: <CreateEarnPage symbol={symbol} />,
  wrapperClassName: 'start-earn-popup',
  hideCloseIcon: false,
  closeOnClickOutside: false,
});

export default CreateEarnPopup;
